<div
  class="sp-pill sp-row__align"
  [ngClass]="pill_class">
  <mat-icon
    *ngIf="is_icon_enabled && icon"
    [ngClass]="icon_class"
    class="sp-margin__right-x2 sp-icon__min-width">
    {{ icon }}
  </mat-icon>
  <p
    *ngIf="!is_large_text_enabled"
    [ngClass]="content_class"
    class="sp-text__ellipsized">
    {{ content || '' | translate }}
  </p>
  <h3
    *ngIf="is_large_text_enabled"
    [ngClass]="content_class"
    class="sp-text__ellipsized">
    {{ content || '' | translate }}
  </h3>
  <mat-icon
    *ngIf="is_clear_enabled"
    (click)="clear_click.emit()"
    [ngClass]="clear_icon_class"
    style="margin-right: -8px; margin-top: 4px; margin-bottom: 4px"
    class="sp-cursor__pointer sp-margin__left-x2 sp-icon__min-width">
    cancel
  </mat-icon>
</div>
